import { z } from "zod";
/**
 * Auth0 Configuration Schema
 */
export const auth0ConfigSchema = z.object({
    domain: z.string().min(1, "Auth0 domain is required"),
    clientId: z.string().min(1, "Auth0 client ID is required"),
    audience: z.string().min(1, "Auth0 audience is required"),
    redirectUri: z.string().url("Valid redirect URI is required").optional(),
    scope: z.string().default("openid profile email"),
});
/**
 * Validate Auth0 configuration
 */
export function validateAuth0Config(config) {
    try {
        const result = auth0ConfigSchema.safeParse(config);
        if (result.success) {
            return { success: true, data: result.data };
        }
        else {
            const errorMessage = result.error.errors
                .map((err) => `${err.path.join(".")}: ${err.message}`)
                .join(", ");
            return { success: false, error: errorMessage };
        }
    }
    catch {
        return { success: false, error: "Auth0 configuration validation failed" };
    }
}
/**
 * Default Auth0 configuration for development
 * NOTE: Replace these values with your actual Auth0 configuration
 */
export const DEFAULT_AUTH0_CONFIG = {
    domain: "your-auth0-domain.auth0.com",
    clientId: "your-auth0-client-id",
    audience: "https://api.deadmantrigger.com",
    redirectUri: typeof window !== "undefined" ? window.location.origin : undefined,
    scope: "openid profile email",
};
/**
 * Get Auth0 configuration from environment
 */
export function getAuth0Config() {
    // Try to get from environment variables first
    if (typeof window !== "undefined" && window.__AUTH0_CONFIG__) {
        const envConfig = window.__AUTH0_CONFIG__;
        const validation = validateAuth0Config(envConfig);
        if (validation.success) {
            return validation.data;
        }
    }
    // Try Vite environment variables
    if (import.meta.env) {
        const env = import.meta.env;
        const envConfig = {
            domain: env.VITE_AUTH0_DOMAIN,
            clientId: env.VITE_AUTH0_CLIENT_ID,
            audience: env.VITE_AUTH0_AUDIENCE,
            redirectUri: env.VITE_AUTH0_REDIRECT_URI ||
                (typeof window !== "undefined" ? window.location.origin : undefined),
            scope: env.VITE_AUTH0_SCOPE || "openid profile email",
        };
        const validation = validateAuth0Config(envConfig);
        if (validation.success) {
            return validation.data;
        }
    }
    // Fallback to default (development) - use dynamic redirect URI
    return {
        ...DEFAULT_AUTH0_CONFIG,
        redirectUri: typeof window !== "undefined" ? window.location.origin : DEFAULT_AUTH0_CONFIG.redirectUri,
    };
}
//# sourceMappingURL=auth0-config.js.map